var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.items)?_c('model-select',{attrs:{"defaultOptions":_vm.items,"placeholder":"Seleziona fornitore precedente...","id":_vm.idSelected,"canSearch":false,"value":null,"canCreate":false,"showTitle":false,"classes":"px-0","disabled":_vm.disabled},on:{"selected":_vm.onItemSelected}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }